import { useState, useEffect, useCallback } from 'react';
import {
    detectPreferredLocale,
    SUPPORTED_LOCALES,
    DEFAULT_LOCALE,
} from '../utils/locale';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import 'dayjs/locale/es';
import 'dayjs/locale/pt';

export default function useLocale() {
    const [locale, setLocaleState] = useState(() => detectPreferredLocale());

    const setLocale = useCallback((l) => {
        const normalized = String(l || '')
            .split('-')[0]
            .toLowerCase();
        const chosen = SUPPORTED_LOCALES.includes(normalized)
            ? normalized
            : DEFAULT_LOCALE;
        setLocaleState(chosen);
        try {
            localStorage.setItem('locale', chosen);
        } catch (e) {
            // ignore
        }
        try {
            window.dispatchEvent(
                new CustomEvent('localeChanged', { detail: chosen })
            );
            // Reload the page so server-provided translations and data reflect the new locale
            if (typeof window !== 'undefined' && window.location) {
                // small timeout to ensure localStorage updates are flushed
                setTimeout(() => window.location.reload(), 50);
            }
        } catch (e) {
            // ignore
        }
    }, []);

    useEffect(() => {
        try {
            localStorage.setItem('locale', locale);
        } catch (e) {
            // ignore
        }
    }, [locale]);

    // Ensure dayjs uses the selected locale for formatting throughout the app
    useEffect(() => {
        try {
            // dayjs supports 'en','ru','es','pt' locale codes
            dayjs.locale(locale);
        } catch (e) {
            // ignore
        }
    }, [locale]);

    return { locale, setLocale, supported: SUPPORTED_LOCALES };
}
